export default {
  myProgram: '关于推荐计划',
  HSBCCustomInfo: '汇丰中国内部员工推荐奖励细则可登录HRDirect 搜索查看“员工推荐政策”，参照你所在的Entity相应的招聘和内推政策。',
  referralProgramTitle: '关于人才推荐项目',
  referralProgramPowered: '(由“菁客”提供技术支持)',
  HSBCReferralProgramIntro: "参与人才推荐项目的推荐者在成功推荐求职者后即有机会获得推荐奖励。推荐奖励政策的规则由企业制定。<a href='https://mp.weixin.qq.com/s/5448Fxv_B4GP8YRz4ZCHSQ'>&lt;点击查看企业详细推荐规则&gt;</a>。",
  referralProgramIntro: '参与人才推荐项目的推荐者在成功推荐求职者后即有机会获得推荐奖励。推荐奖励政策的规则由企业制定。',
  earningRewardsTitle: '获得奖励',
  earningRewardsIntro: '每个工作奖励的机会都是不同的。您可以基于具体的职位描述，查看其可适用的个人奖励，并通过提供的社交媒体渠道进行职位分享。当某位您社交媒体圈中的朋友通过您分享的链接进行职位申请，您就有机会获得推荐奖励！',
  howTo_referTitle: '通过多种社交媒体渠道和网络进行推荐',
  howTo_referIntro: '通过多种社交媒体渠道和网络来分享职位信息，可以最大化您的获奖机率。您可以根据职位性质和社交圈，来选择最有效的社交媒体渠道进行分享。例如，对于某些职位，您的领英社交圈伙伴可能会最感兴趣，而对于其他工作，也许您的微信朋友更感兴趣。选择您认为最有效的分享渠道，最大化您的获奖机率。',
  myEarningRewardTitle: '我的奖励',
  myEarningRewardIntro: '奖励可以通过企业内部工资或微信红包支付。查看“我的奖励”页面，了解成功推荐的详细信息，奖励金额和付款详情。',
  aboutTaxTitle: '关于税收',
  aboutTaxIntro: '所有推荐奖励均需依法缴纳个人所得税，因此无论您的奖励是通过企业内部工资还是通过微信红包支付，税款都已根据中国人民共和国税法扣除。',
  contactUsTitle: '联系我们',
  contactUsIntro: "如有任何问题或反馈，请将你的联系方式，疑问或发现的问题，发送邮件至<a class='email' href='mailto: rewards@ajinga.com'>rewards@ajinga.com</a>，菁客的顾问会尽快与您取得联系。"
}
